import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import PowerGenerationSourceList from './PowerGenerationSourceList';
import { icon } from 'leaflet';

//redux

const PowerGenerationSource = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
		{ to: '#', label: 'Fuentes de Generación de Energía', icon: 'icon-zap' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Ver Fuentes de Generación de Energía' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<PowerGenerationSourceList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PowerGenerationSource;
